import { checkCustomerAndContinueOnboarding } from '../onboarding-zone/check-customer-and-continue-onboarding.utils';
import { ButtonActionType, UiZoneWidgetAttributeConfig } from '@finxone-platform/shared/sys-config-types';
import { functionCtaType } from '@app/finxone-web-frontend/app/lib/utils/cta-button-actions/cta-button-actions.utils';
import { Injector } from '@angular/core';
import { onboardIndividual } from '@app/finxone-web-frontend/app/lib/utils/cta-button-actions/onboarding-zone/onboarding-actions.utils';
import { onboardingBankDetailsVerification } from '@app/finxone-web-frontend/app/lib/utils/cta-button-actions/onboarding-zone/onboarding-bank-details-verification.utils';
export const onboardingActions: Map<ButtonActionType, functionCtaType> = new Map([
  [ButtonActionType.CHECK_CUSTOMER_AND_CONTINUE_ONBOARDING, checkCustomerAndContinueOnboarding],
  [
    ButtonActionType.ONBOARDING_SUBMIT,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      onboardIndividual(injector, attri.widgetProperties);
    },
  ],
  [
    ButtonActionType.ONBOARDING_BANK_DETAILS_VERIFICATION,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      onboardingBankDetailsVerification(injector, attri.widgetProperties);
    },
  ],
]);
